unit DepartmentListType;
{

/* Initial. */

}

interface

uses
  DepartmentType;

type
  TDepartmentListType = array of TDepartmentType;

implementation

end.
